import { useEffect, useState } from "react";
import { createNewSupportCallFetch, fetchAllDnsBySearch, fetchDnsOptions, fetchSupportOccurrenceOrigins, fetchSupportRegionals } from "../api/fetchNewSupportCall";
import { FetchNewSupportCallProps, IPagedSelectOptionItens, IPagedSelectOption, IPagedSelectResponse, IGetIPagedSelectProps, IDnOptionItens, IGetAllDnsOptionsResponse } from "../models/newSupportCall";
import type { GroupBase, OptionsOrGroups } from 'react-select';
import { fetchBudgetUserProfile } from "../api/fetchBudget";
import { VehicleSupport } from "../pages/support/types";
import { fetchSupportVehicle } from "../api/tas";

const useNewSupportCall = () => {
  const [pageRegionals, setPageRegionals] = useState(0);
  const [pageOccurrenceOrigins, setPageOccurrenceOrigins] = useState(0);
  const [dnOptions, setDnOptions] = useState<IDnOptionItens[]>([]);
  const [role, setRole] = useState('');

  const [selectedRegional, setSelectedRegional] = useState<IPagedSelectOptionItens | null>(null);
  const [selectedOccurrenceOrigin, setSelectedOccurrenceOrigin] = useState<IPagedSelectOptionItens | null>(null);
  const [vehicle, setVehicle] = useState<VehicleSupport | null>(null);
  const [isLoadingVehicleFetch, setIsLoadingVehicleFetch] = useState(false);

  const fetchVehicle = async (chassis: string) => {
      setIsLoadingVehicleFetch(true);

      try {
          const res = await fetchSupportVehicle(chassis);
          setVehicle(res);

      } catch (error) {
          setVehicle(null);
      } finally {
          setIsLoadingVehicleFetch(false);
      }
  }

  const createSupportCall = async (props: FetchNewSupportCallProps) => {
    const response = await createNewSupportCallFetch(props);

    return response;
  };


  const getSelectOptions = async (
    page: number,
    setPage: React.Dispatch<React.SetStateAction<number>>,
    fetchFunction: (props: IGetIPagedSelectProps) => Promise<IPagedSelectResponse | null>
  ): Promise<IPagedSelectOption> => {
    const pageValue = page + 1;
    const response = await fetchFunction({ page, size: 10 });

    if (!response) {
      console.error("Erro ao buscar regionais de suporte");
      return { options: [], hasMore: false };
    }

    const isLastPage = response?.last;

    const itens =  response?.content.map(item => ({
      value: item.id,
      label: item.name,
    }));


    setPage(pageValue);
    return {
      options: itens,
      hasMore: !isLastPage,
    };
  };

  const getSupportRegionals = async (
    _search: string,
    _prevOptions: OptionsOrGroups<IPagedSelectOptionItens, GroupBase<IPagedSelectOptionItens>>
  ): Promise<IPagedSelectOption> => {
    return await getSelectOptions(pageRegionals, setPageRegionals, fetchSupportRegionals);
  }

  const getSupportOccurrenceOrigins = async (
    _search: string,
    _prevOptions: OptionsOrGroups<IPagedSelectOptionItens, GroupBase<IPagedSelectOptionItens>>
  ): Promise<IPagedSelectOption> => {
    return await getSelectOptions(pageOccurrenceOrigins, setPageOccurrenceOrigins, fetchSupportOccurrenceOrigins);
  }

  const getUserRole = async ()  => {
    const userProfileData = await fetchBudgetUserProfile();
    
    setRole(userProfileData || '')
  }

  const getAllDns = async (
    searchTerm: string,
    pageSize: number,
    page: number
  ): Promise<IGetAllDnsOptionsResponse[]> => {

    const response = await fetchAllDnsBySearch(searchTerm || 'dibracam')

    if(!response) return []

    const options = response?.map(option => {
      return {
        id: option.fantasyName,
        label: `DN: ${option.id} | Nome: ${option.fantasyName} | Endereço: ${option.neighborhood}, ${option.city} - ${option.state}`
      }
    })

    return options
  }

  useEffect(() => {
    const loadData = async () => {
      const response = await fetchDnsOptions()

      if(!response) return []

      const itens = response?.dns
        ?.map(item => ({
          value: item.dnName, 
          label: `DN: ${item.dn} | Nome: ${item.dnName} | Endereço: ${item.address}, ${item.neighborhood}, ${item.city} - ${item.state}`
        })) || []

      setDnOptions(itens)
    }

    loadData()
    getUserRole()
  }, [])

  return { 
    selectedRegional,
    selectedOccurrenceOrigin,
    dnOptions,
    role,
    vehicle,
    isLoadingVehicleFetch,
    fetchVehicle,
    createSupportCall, 
    getSupportRegionals,
    getAllDns,
    getSupportOccurrenceOrigins,
    setSelectedRegional,
    setSelectedOccurrenceOrigin
  };
};

export default useNewSupportCall;